import { useMemo } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { Layout } from "../../components/Layout";
import { MsgProvider } from "../../components/Msg";
import { useMsg } from "../../components/Msg/Msg";
import { useAuth } from "../Authorization";
import { AdminSettings } from "./AdminSettings";
import { AvailabilitySettings } from "./AvailabilitySettings/AvailabilitySettings";
import { CoachProfileSettings } from "./CoachProfile/CoachProfileSettings";
import { CompaniesSettings } from "./CompaniesSettings";
import { GeneralSettings } from "./GeneralSettings";
import { settingsMessages } from "./messages";
import { TLTabs } from "./Tabs";
import { UserCreditsSettings } from "./UserCreditsSettings";
// import { UserProfileSettings } from "./UserProfileSettings";

export const WHITE_BG = { "& .MuiOutlinedInput-root": { bgcolor: "white" } };

export const SETTINGS_TABS = {
  PROFILE: "PROFILE",
  USER_PROFILE: "USER_PROFILE",
  GENERAL: "GENERAL",
  USER_CREDITS: "USER_CREDITS",
  AVAILABILITY: "AVAILABILITY",
  ADMIN: "ADMIN",
  COMPANIES: "COMPANIES",
};

function SettingsPageInner() {
  const msg = useMsg();
  const { isCoach, isAdmin } = useAuth();

  const tabs = useMemo(() => {
    const tabs = [
      {
        key: SETTINGS_TABS.PROFILE,
        visible: isCoach,
        label: msg("settings.tabs.profile.label"),
        Component: CoachProfileSettings,
      },
      {
        visible: true,
        key: SETTINGS_TABS.GENERAL,
        label: msg("settings.tabs.general.label"),
        Component: GeneralSettings,
      },
      // {
      //   visible: !isCoach,
      //   key: SETTINGS_TABS.USER_PROFILE,
      //   label: msg("settings.tabs.profile.label"),
      //   Component: UserProfileSettings,
      // },
      {
        visible: true,
        key: SETTINGS_TABS.USER_CREDITS,
        label: msg("settings.tabs.credits.label"),
        Component: UserCreditsSettings,
      },
      {
        visible: isCoach,
        key: SETTINGS_TABS.AVAILABILITY,
        label: msg("settings.tabs.availability.label"),
        Component: AvailabilitySettings,
      },
      {
        visible: isAdmin,
        key: SETTINGS_TABS.ADMIN,
        label: msg("settings.tabs.admin.label"),
        Component: AdminSettings,
      },
      {
        visible: isAdmin,
        key: SETTINGS_TABS.COMPANIES,
        // label: msg("settings.tabs.admin.companies"),
        label: "Companies",
        Component: CompaniesSettings,
      },
    ];
    return tabs;
  }, [isAdmin, isCoach, msg]);

  console.log("[SettingsPageInner.rndr]", { tabs });

  return (
    <Layout
      header={{
        noDivider: true,
        heading: msg("settings.heading"),
      }}
    >
      <ErrorBoundary
        fallbackRender={({ error, resetErrorBoundary }) => {
          console.log({ error });
          return error.message;
        }}
      >
        <TLTabs tabs={tabs} />
      </ErrorBoundary>
    </Layout>
  );
}

export function SettingsPage() {
  return (
    <MsgProvider messages={settingsMessages}>
      <SettingsPageInner />
    </MsgProvider>
  );
}
